import { alpha } from '@mui/material/styles';
// ----------------------------------------------------------------------

export default function Button(theme) {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 400,
          fontSize: '14px',
          textTransform: 'none',
          borderRadius: '8px',
        },
        sizeLarge: {
          height: '45px',
          padding: '11px 22px',
        },
        sizeMedium: {
          height: '39px',
          padding: '6px 16px',
        },
        sizeSmall: {
          height: '33px',
          padding: '4px 10px',
        },
        disabled: {
          backgroundColor: theme.palette.grey[100],
          color: theme.palette.grey[400],
        },
        // contained
        containedInherit: {
          color: theme.palette.common.white,
        },
        containedPrimary: {
          '&:hover': {
            backgroundColor: theme.palette.primary.palette[800],
          },
        },
        containedSecondary: {
          '&:hover': {
            backgroundColor: theme.palette.secondary.palette[800],
          },
        },
        // outlined
        outlinedPrimary: {
          'backgroundColor':
            theme.palette.mode === 'light'
              ? theme.palette.primary.palette[50]
              : theme.palette.grey[800],
          'border':
            theme.palette.mode === 'light'
              ? `1px solid ${alpha(theme.palette.primary.palette[600], 0.5)}`
              : 'none',
          '&:hover': {
            backgroundColor:
              theme.palette.mode === 'light'
                ? theme.palette.primary.palette[100]
                : theme.palette.grey[600],
          },
          'color':
            theme.palette.mode === 'light'
              ? theme.palette.primary.main
              : theme.palette.common.white,
        },
        outlinedSecondary: {
          'backgroundColor':
            theme.palette.mode === 'light'
              ? theme.palette.secondary.palette[50]
              : theme.palette.grey[800],
          'border':
            theme.palette.mode === 'light'
              ? `1px solid ${alpha(theme.palette.secondary.palette[600], 0.5)}`
              : 'none',
          '&:hover': {
            backgroundColor:
              theme.palette.mode === 'light'
                ? theme.palette.secondary.palette[100]
                : theme.palette.grey[600],
          },
          'color':
            theme.palette.mode === 'light'
              ? theme.palette.secondary.main
              : theme.palette.common.white,
        },
        textInherit: {
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
        },
      },
      variants: [
        {
          props: { variant: 'default' },
          style:
            theme.palette.mode === 'light'
              ? {
                  'color': theme.palette.grey[900],
                  'backgroundColor': theme.palette.grey[300],
                  '&:hover': {
                    backgroundColor: theme.palette.primary.palette[100],
                  },
                }
              : {
                  'color': theme.palette.grey[100],
                  'backgroundColor': theme.palette.grey[900],
                  '&:hover': {
                    backgroundColor: theme.palette.grey[600],
                  },
                },
        },
        {
          props: { variant: 'ghost' },
          style:
            theme.palette.mode === 'light'
              ? {
                  'borderRadius': '8px',
                  'border': '1px solid rgba(137, 150, 162, 0.32)',
                  'color': theme.palette.grey[400],
                  'backgroundColor': theme.palette.common.white,
                  'fontSize': '14px',
                  'fontWeight': 400,
                  '&:hover': {
                    backgroundColor: theme.palette.primary.palette[100],
                  },
                }
              : {
                  'borderRadius': '8px',
                  'border': '1px solid rgba(137, 150, 162, 0.32)',
                  'color': theme.palette.grey[200],
                  'backgroundColor': theme.palette.grey[900],
                  'fontSize': '14px',
                  'fontWeight': 400,
                  '&:hover': {
                    backgroundColor: theme.palette.grey[600],
                  },
                },
        },
        {
          props: { variant: 'outlined-rounded', color: 'primary' },
          style:
            theme.palette.mode === 'light'
              ? {
                  'color': theme.palette.primary.main,
                  'backgroundColor': theme.palette.primary.palette[50],
                  'border': `1px solid ${alpha(
                    theme.palette.primary.palette[600],
                    0.5,
                  )}`,
                  '&:hover': {
                    backgroundColor: theme.palette.primary.palette[100],
                  },
                }
              : {
                  'color': theme.palette.common.white,
                  'backgroundColor': theme.palette.grey[800],
                  '&:hover': {
                    backgroundColor: theme.palette.grey[600],
                  },
                },
        },
        {
          props: { variant: 'outlined-rounded', color: 'secondary' },
          style:
            theme.palette.mode === 'light'
              ? {
                  'color': theme.palette.secondary.main,
                  'backgroundColor': theme.palette.secondary.palette[50],
                  'border': `1px solid ${alpha(
                    theme.palette.secondary.palette[600],
                    0.5,
                  )}`,
                  '&:hover': {
                    backgroundColor: theme.palette.secondary.palette[100],
                  },
                }
              : {
                  'color': theme.palette.common.white,
                  'backgroundColor': theme.palette.grey[800],
                  '&:hover': {
                    backgroundColor: theme.palette.grey[600],
                  },
                },
        },
        {
          props: { variant: 'outlined-rounded', size: 'small' },
          style: {
            borderRadius: `17px`,
            height: '33px',
            padding: '4px 10px',
          },
        },
        {
          props: { variant: 'outlined-rounded', size: 'medium' },
          style: {
            borderRadius: `20px`,
            height: '39px',
            padding: '6px 16px',
          },
        },
        {
          props: { variant: 'outlined-rounded', size: 'large' },
          style: {
            borderRadius: `24px`,
            height: '45px',
            padding: '11px 22px',
          },
        },
        {
          props: { variant: 'contained-rounded', color: 'primary' },
          style: {
            'color': theme.palette.common.white,
            'backgroundColor': theme.palette.primary.palette[500],
            '&:hover': {
              backgroundColor: theme.palette.primary.palette[800],
            },
          },
        },
        {
          props: { variant: 'contained-rounded', color: 'secondary' },
          style: {
            'color': theme.palette.common.white,
            'backgroundColor': theme.palette.secondary.palette[500],
            '&:hover': {
              backgroundColor: theme.palette.secondary.palette[800],
            },
          },
        },
        {
          props: { variant: 'contained-rounded', size: 'small' },
          style: {
            borderRadius: `17px`,
            height: '33px',
            padding: '4px 10px',
          },
        },
        {
          props: { variant: 'contained-rounded', size: 'medium' },
          style: {
            borderRadius: `20px`,
            height: '39px',
            padding: '6px 16px',
          },
        },
        {
          props: { variant: 'contained-rounded', size: 'large' },
          style: {
            borderRadius: `24px`,
            height: '45px',
            padding: '11px 22px',
          },
        },
      ],
    },
  };
}
